import g from './globals/variables'
import A11y from './globals/a11y'
import Animations from './components/animations'
import Accordion from './components/accordion'
import Counter from './components/counter'
import Video from './components/video'
import Augl from './components/augl'
import Modal from './components/modal'
import Header from 'components/header'
import Tabs from './components/tabs'
import InstantSearch from './components/instant-search'
import Filter from './components/filter'
import Customer from './components/customer'
import UlAccords from './components/ulaccords'
import Pamphlets from './components/pamphlets'
import Datepicker from './components/datepicker'
import DatepickerRange from './components/datepicker-range'
import SelectAllOrders from './components/selectAllOrders'

import MyPageUsers from './components/mypageUsers'
import UserManagement from './components/mypageUsermanagement'
import Saga from './components/saga'
import FieldControls from './components/fieldControls'
import FormSubmit from './components/Forms/RecaptchaFormSubmit'
import HyphenateText from './components/hyphenateText'
import HeroVideo from './components/hero-video'
import KonfektPage1 from 'components/konfekt-page-1'
import KonfektPage2 from 'components/konfekt-page-2'
import PaskaPage1 from 'components/paska-2026-page-1'
import PlataArsinsPage from 'components/plata-arsins-2026'
import AddToCart from './components/addToCart'
import CartlistItem from './components/cartlistItem'
import CartControls from './components/cartControls'
import RemoveFromCart from './components/removeFromCart'
import ProductListTable from './components/productListTable '
import CheckoutForm from './components/Forms/CheckoutForm'
import OrderlineAddRemove from './components/orderlineAddRemove'
import Reorder from './components/reorder'
import Auth from 'components/auth'

// recipes website
import NoiSwiper from './components/swiper'
import RecipesAnimations from './components/recipes-animations'
import RecipesLines from 'components/recipes-lines-animations'
import RecipesNavigation from './components/recipes-navigation'
// import NewsletterBlock from './components/newsletter'

// components
g.el.accordions.forEach((target) => Accordion.init(target))
g.el.counters.forEach((target) => Counter.init(target))
g.el.videos.forEach((target) => Video.init(target))
g.el.augl.forEach((target) => Augl.init(target))
g.el.vidmodal.forEach((target) => Augl.init(target))
g.el.modal.forEach((target) => Modal.init(target))
g.el.header.forEach((target) => Header(target))
g.el.tabs.forEach((target) => Tabs.init(target))
document.querySelectorAll<HTMLElement>('[data-noi-instant-search]').forEach((target) => InstantSearch.init(target))
g.el.productFilters.forEach((target) => Filter.init(target))
g.el.customers.forEach((target) => Customer.init(target))
g.el.ulAccords.forEach((target) => UlAccords.init(target))
g.el.saga.forEach((target) => Saga.init(target))
g.el.fieldControls.forEach((target) => FieldControls.init(target))
g.el.hyphenText.forEach((target) => HyphenateText.init(target))
g.el.pamphlets.forEach((target) => Pamphlets.init(target))
g.el.recipesNavigationMobile.forEach((target) => RecipesNavigation(target))
// g.el.newsletterBlocks.forEach((target) => NewsletterBlock(target))
g.el.cartlistItems.forEach((target) => CartlistItem.init(target))
g.el.productListTableProduct.forEach((target) => CartlistItem.init(target))
g.el.datepickersRange.forEach((target) => DatepickerRange.init(target))
g.el.datepickers.forEach((target) => {
  if (!target.hasAttribute('data-isRange')) {
    Datepicker.init(target)
  }
})
g.el.orderListSelectAll.forEach((target) => SelectAllOrders.init(target))
g.el.addToCart.forEach((target) => AddToCart.init(target))
g.el.removeFromCart.forEach((target) => RemoveFromCart.init(target))
g.el.productListTables.forEach((target) => ProductListTable.init(target))
g.el.orderListAddRemove.forEach((target) => OrderlineAddRemove.init(target))
g.el.refreshBtns.forEach((target) => Reorder.init(target))

if (g.cartControls) {
  CartControls.init(g.cartControls)
}

if (g.form.contact) {
  FormSubmit.init(g.form.contact)
}

if (g.form.checkout) {
  CheckoutForm.init(g.form.checkout)
}

if (document.querySelector('.swiper__container, .swiper-container')) {
  NoiSwiper.init()
}

if (!document.querySelector('.konfekt-page')) {
  Animations.init()
  RecipesAnimations.init()
  RecipesLines.init()
}

A11y.init()
MyPageUsers.init()
UserManagement.init()
HeroVideo.init()
Auth.init()

if (document.querySelector('.konfekt-page')) {
  KonfektPage1.init()
  KonfektPage2.init()
}

if (document.querySelector('.paska-page')) {
  PaskaPage1.init()
}

if (document.querySelector('.plata-arsins-page')) {
  PlataArsinsPage.init()
}

if (process.env.NODE_ENV !== 'production') {
  new EventSource('https://localhost:9000/esbuild').addEventListener('change', (e) => {
    const { added, removed, updated } = JSON.parse(e.data)

    if (!added.length && !removed.length && updated.length === 1) {
      for (const link of document.getElementsByTagName('link') as any) {
        const url = new URL(link.href)

        if (url.host === location.host && url.pathname === updated[0]) {
          const next = link.cloneNode()
          next.href = `${updated[0]}?${Math.random().toString(36).slice(2)}`
          next.onload = () => link.remove()
          link.parentNode.insertBefore(next, link.nextSibling)
          return
        }
      }
    }

    location.reload()
  })
}
